import RouterViewBody from '~/views/RouterViewBody.vue'
import routerSettingInterfaceWeb from '../../modules/setting/interface/routerSettingInterfaceWeb'
import routerSettingInterfaceMob from '../../modules/setting/interface/routerSettingInterfaceMob'
import routerSettingInterfaceMail from '../../modules/setting/interface/routerSettingInterfaceMail'
import store from '../../../store/index.js'
export default [
  {
    path: 'setting',
    component: () => import('~/views/template/ViewsTemplateMain.vue'),
    props: { type: 'setting' },
    meta: {
      breadCrumbLocalStorage: 'translations',
      breadCrumb: (translation) => translation.pages.pages.buttons.nastroyki,
    },
    children: [
      {
        path: '',
        name: 'Setting',
        component: () => import('~/views/settingPage/allSetting.vue'),
        meta: {
          responsive: true,
        },
      },
      {
        path: 'personal-area',
        component: RouterViewBody,
        meta: {
          responsive: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['lichnyy-kabinet'],
        },
        children: [
          {
            path: '',
            name: 'PersonalArea',
            component: () => import('~/views/personalArea/personalArea.vue'),
            meta: {
              responsive: true,
            },
          },
          {
            path: 'edit',
            name: 'PersonalAreaEdit',
            component: () => import('~/views/personalArea/personalAreaAdministration.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.common.breadcrumbs['redaktirovanie'],
            },
          },
          {
            path: 'pdf',
            name: 'PersonalAreaPdf',
            component: () => import('~/views/personalArea/personalAreaPdf.vue'),
            meta: {
              breadCrumb: 'PDF',
            },
          },
        ],
      },
      {
        path: 'users',
        component: RouterViewBody,
        meta: {
          access: { abilities: ['view_users'] },
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['polzovateli'],
        },
        children: [
          {
            path: '',
            name: 'SettingUsers',
            component: () => import('~/views/settingPage/settingsUsers.vue'),
            meta: {
              search: true,
              responsive: true,
              paginations: {
                page: 1,
                limit: 10,
                style_list: 'table',
              },
            },
          },
          {
            path: 'subscribers',
            name: 'SettingUsers-subscribers',
            component: () => import('~/views/settingPage/settingsUsers.vue'),
            meta: {
              access: { abilities: 'view_project_subscribers' },
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['sales_project']['planned_resources-subscribers'].title,
              search: true,
              responsive: true,
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
        ],
      },
      {
        path: 'interface',
        component: RouterViewBody,
        meta: {
          access: { userType: 'superadmin' },
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) =>
            translation.pages.setting.pages['administrirovanie-interfeysa'],
        },
        children: [
          {
            path: '',
            name: 'settingInterface',
            component: () => import('~/views/settingPage/interface/settingInterface.vue'),
          },
          ...routerSettingInterfaceWeb,
          ...routerSettingInterfaceMob,
          ...routerSettingInterfaceMail,
        ],
      },
      {
        path: 'languages',
        name: 'settingLanguages',
        component: () => import('~/views/settingPage/settingLanguages.vue'),
        meta: {
          responsive: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['yazyk-interfeysa'],
        },
      },
      {
        path: 'offer-agreement',
        component: RouterViewBody,
        meta: {
          responsive: true,
          access: { userType: 'superadmin' },
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages.offer_agreement,
        },
        children: [
          {
            path: '',
            name: 'settingOfferAgreement',
            component: () => import('~/views/settingPage/settingOfferAgreement.vue'),
            meta: {
              responsive: true,
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
          {
            path: 'create',
            name: 'settingOfferAgreementCreate',
            component: () => import('~/views/settingPage/settingOfferAgreementShow.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.common.breadcrumbs.sozdanie,
            },
          },
          {
            path: ':id',
            component: RouterViewBody,
            meta: {
              responsive: true,
              breadCrumbGetter: 'offerAgreement/offerAgreementShow',
              breadCrumb: (offer) => offer.name,
            },
            children: [
              {
                path: '',
                name: 'settingOfferAgreementShow',
                component: () => import('~/views/settingPage/settingOfferAgreementShow.vue'),
                meta: {
                  responsive: true,
                }
              },
              {
                path: 'edit',
                name: 'settingOfferAgreementShowEdit',
                component: () => import('~/views/settingPage/settingOfferAgreementShow.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.common.breadcrumbs.redaktirovanie,
                },
              },
            ],
          },
        ],
      },
      {
        path: 'roles',
        component: RouterViewBody,
        meta: {
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['roli'],
          access: {
            abilities: ['view_roles'],
          },
          responsive: true,
        },
        children: [
          {
            path: '',
            name: 'SettingRoles',
            component: () => import('~/views/settingPage/roles.vue'),
            meta: {
              // search: true,
              paginations: {
                page: 1,
                limit: 10,
              },
              responsive: true,
            },
          },
          {
            path: 'create',
            name: 'SettingRolesCreate',
            component: () => import('~/views/settingPage/rolesCreateUpdate.vue'),
            meta: {
              access: {
                abilities: ['edit_roles'],
              },
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.common.breadcrumbs['sozdanie'],
              responsive: true,
            },
          },
          {
            path: ':id',
            name: 'SettingRolesUpdate',
            component: () => import('~/views/settingPage/rolesCreateUpdate.vue'),
            props: true,
            meta: {
              access: {
                abilities: ['edit_roles'],
              },
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.common.breadcrumbs['redaktirovanie'],
              responsive: true,
            },
          },
        ],
      },
      {
        path: 'business-segment',
        name: 'SettingBusinessSegment',
        component: () => import('~/views/settingPage/settingBusinessSegment.vue'),
        meta: {
          icon: 'pages-settings-business_segment',
          access: { abilities: ['view_business_segments'], userType: 'user' },
          responsive: true,
          search: true,
          paginations: {
            page: 1,
            limit: 10,
          },
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) =>
            translation.pages.setting.pages['segmenty-vida-deyatelnosti'],
        },
      },
      {
        path: 'work-type',
        name: 'SettingWorkTypes',
        component: () => import('~/views/settingPage/settingWorkTypes.vue'),
        meta: {
          access: { abilities: ['view_work_type'], userType: 'user' },
          responsive: true,
          // search: true,
          paginations: {
            page: 1,
            limit: 10,
          },
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['vidy-rabot'],
        },
      },
      {
        path: 'work-extra-type',
        name: 'SettingWorkExtraType',
        component: () => import('~/views/settingPage/settingWorkExtraType.vue'),
        meta: {
          access: { abilities: ['view_work_extra_types'], userType: 'user' },
          responsive: true,
          search: true,
          paginations: {
            page: 1,
            limit: 10,
          },
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['vidy-dopolnitelnyh-rabot'],
        },
      },
      {
        path: 'work-type-category',
        name: 'SettingWorkTypesCategory',
        component: () => import('~/views/settingPage/settingWorkTypesCategory.vue'),
        meta: {
          access: { abilities: ['view_work_type'], userType: 'user' },
          responsive: true,
          search: true,
          paginations: {
            page: 1,
            limit: 10,
          },
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['kategorii-rabot'],
        },
      },

      {
        path: 'project-type',
        name: 'SettingProjectType',
        component: () => import('~/views/settingPage/settingProjectType.vue'),
        meta: {
          access: { abilities: ['view_project_types'], userType: 'user' },
          responsive: true,
          // search: true,
          paginations: {
            page: 1,
            limit: 10,
          },
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['tipy-proektov'],
        },
      },

      {
        path: 'region',
        name: 'SettingWorkRegion',
        component: () => import('~/views/settingPage/settingWorkRegion.vue'),
        meta: {
          access: { abilities: ['view_regions'] },
          responsive: true,
          search: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['regiony'],
          paginations: {
            page: 1,
            limit: 10,
          },
        },
      },
      {
        path: 'employee-roles',
        name: 'SettingEmployeeRoles',
        component: () => import('~/views/settingPage/settingEmployeeRoles.vue'),
        meta: {
          access: { abilities: ['view_work_roles'], userType: 'user' },
          responsive: true,
          search: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['dolzhnosti'],
          paginations: {
            page: 1,
            limit: 10,
          },
        },
      },
      {
        path: 'scheme-type',
        name: 'SettingWorkDocsSchemeType',
        component: () => import('~/views/settingPage/settingWorkDocsSchemeType.vue'),
        meta: {
          access: { abilities: ['view_scheme_types'], userType: 'user' },
          responsive: true,
          search: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['tip-chertezha'],
          paginations: {
            page: 1,
            limit: 10,
          },
        },
      },
      {
        path: 'scheme-class',
        name: 'SettingWorkDocsSchemeClass',
        component: () => import('~/views/settingPage/settingWorkDocsSchemeClass.vue'),
        meta: {
          access: { abilities: ['view_scheme_classes'], userType: 'user' },
          responsive: true,
          search: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['soderzhanie-chertezhey'],
          paginations: {
            page: 1,
            limit: 10,
          },
        },
      },
      {
        path: 'document-type',
        name: 'SettingWorkDocsDocumentType',
        component: () => import('~/views/settingPage/settingWorkDocsDocumentType.vue'),
        meta: {
          access: { abilities: ['view_document_types'], userType: 'user' },
          responsive: true,
          search: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['tip-dokumenta'],
          paginations: {
            page: 1,
            limit: 10,
          },
        },
      },
      {
        path: 'work-area',
        component: () => import('~/views/settingPage/settingWorkDocsWorkArea.vue'),
        meta: {
          access: { abilities: ['view_work_areas'], userType: 'user' },
          responsive: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['zona-raboty'],
        },
        children: [
          {
            path: '',
            name: 'SettingWorkDocsWorkArea',
            component: () => import('~/views/settingPage/settingWorkDocsWorkArea.vue'),
            meta: {
              responsive: true,
              search: true,
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
          {
            path: ':id',
            name: 'SettingWorkDocsWorkAreaProject',
            component: () => import('~/views/settingPage/settingWorkDocsWorkArea.vue'),
            meta: {
              responsive: true,
              search: true,
              breadCrumbGetter: 'workClientProject/workClientProjectShow',
              breadCrumb: (project) => project.name,
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
        ],
      },
      {
        path: 'structure-company',
        name: 'SettingStructureCompany',
        component: () => import('~/views/settingPage/settingStructureCompany.vue'),
        meta: {
          access: { abilities: ['edit_work_roles'], userType: 'user' },
          responsive: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['structure_company'],
        },
      },
      {
        path: 'company',
        name: 'SettingCompany',
        component: () => import('views/settingPage/company/settingCompany.vue'),
        meta: {
          responsive: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['setting_company'],
        },
        children: [
          {
            path: 'general',
            name: 'SettingCompanyGeneral',
            component: () => import('views/settingPage/company/settingCompanyMainSettings.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting-setting_company'].all['main'],
              access: { abilities: ['edit_general_settings'] },
            },
            children: [
              {
                path: 'edit',
                name: 'SettingCompanyGeneralEdit',
                component: () => import('views/settingPage/company/settingCompanyMainSettings.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.common.breadcrumbs.redaktirovanie,
                },
              },
            ],
          },
          {
            path: 'geoposition',
            name: 'SettingCompanyGeoPosition',
            component: () => import('views/settingPage/company/settingCompanyGeoPosition.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-setting_company'].all['geoposition'],
              access: { abilities: ['edit_geo_position_settings'] },
            },
            children: [
              {
                path: 'edit',
                name: 'SettingCompanyGeoPositionEdit',
                component: () => import('views/settingPage/company/settingCompanyGeoPosition.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.common.breadcrumbs.redaktirovanie,
                },
              },
            ],
          },
          {
            path: 'start-stop',
            name: 'SettingCompanyStartStop',
            component: () => import('views/settingPage/company/settingCompanyStartStop.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-setting_company'].all['start_stop'],
              access: { abilities: ['edit_geo_position_settings'] },
            },
            children: [
              {
                path: 'edit',
                name: 'SettingCompanyStartStopEdit',
                component: () => import('views/settingPage/company/settingCompanyStartStop.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.common.breadcrumbs.redaktirovanie,
                },
              },
            ],
          },
          {
            path: 'calendar',
            name: 'SettingCompanyCalendar',
            component: () => import('views/settingPage/company/settingCompanyCalendar.vue'),
            meta: {
              access: { abilities: ['edit_mobile_calendar_settings'] },
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-setting_company'].all['mobile_calendar'],
            },
            children: [
              {
                path: 'edit',
                name: 'SettingCompanyCalendarEdit',
                component: () => import('views/settingPage/company/settingCompanyCalendar.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.common.breadcrumbs.redaktirovanie,
                },
              },
            ],
          },
          {
            path: 'financial-system',
            name: 'SettingCompanyFinancialSystem',
            component: () => import('views/settingPage/company/settingCompanyFinancialSystem.vue'),
            meta: {
              access: { abilities: ['edit_financial_settings'] },
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-setting_company'].all['fin-system'],
            },
            children: [
              {
                path: 'edit',
                name: 'SettingCompanyFinancialSystemEdit',
                component: () => import('views/settingPage/company/settingCompanyFinancialSystem.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.common.breadcrumbs.redaktirovanie,
                },
              },
            ],
          },
          {
            path: 'salary-settings',
            name: 'SettingCompanySalarySettings',
            component: () => import('views/settingPage/company/settingCompanySalarySettings.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-setting_company'].all['salary_settings'] || 'Salary settings',
            },
          },
          {
            path: 'project',
            name: 'SettingCompanyProject',
            component: () => import('views/settingPage/company/settingCompanyProject.vue'),
            meta: {
              access: { userType: 'superadmin' },
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-setting_company'].all['project_settings'],
            },
            children: [
              {
                path: 'edit',
                name: 'SettingCompanyProjectEdit',
                component: () => import('views/settingPage/company/settingCompanyProject.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.common.breadcrumbs.redaktirovanie,
                },
              },
            ],
          },
        ],
      },
      {
        path: 'push-notifications',
        name: 'settingsPushNotifications',
        redirect: () => {
          return {
            name:
              store.getters['user/userType'] === 'superadmin'
                ? 'settingsPushNotificationsManual'
                : 'settingsPushNotificationsHistory',
          }
        },
        component: () =>
          import('~/views/settingPage/pushNotifications/settingsPushNotifications.vue'),
        meta: {
          responsive: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.setting.pages['push_notifications'],
        },
        children: [
          {
            path: '',
            name: 'settingsPushNotificationsHistory',
            component: () =>
              import('~/views/settingPage/pushNotifications/settingsPushNotificationsHistory.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['common'].text['history'],
            },
          },
          {
            path: 'manual',
            name: 'settingsPushNotificationsManual',
            component: () =>
              import('~/views/settingPage/pushNotifications/settingsPushNotificationsEdit.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-push_notifications'].main['push-manual'],
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
          {
            path: 'triggered',
            name: 'settingsPushNotificationsTriggered',
            component: () =>
              import('~/views/settingPage/pushNotifications/settingsPushNotificationsEdit.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                translation.pages['setting-push_notifications'].main['push-triggered'],
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
          {
            path: 'projects',
            name: 'settingsPushNotificationsProjects',
            component: () =>
                import('~/views/settingPage/pushNotifications/settingsPushNotificationsEdit.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) =>
                  translation.pages['setting-push_notifications'].main['push-triggered-projects'],
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
        ],
      },
      {
        path: 'finance',
        component: () => import('views/settingPage/finance/settingFinance.vue'),
        meta: {
          //access: { abilities: [], userType: 'user' },
          responsive: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.pages.buttons.finance,
          paginations: {
            page: 1,
            limit: 10,
          },
        },
        children: [
          {
            path: '/',
            name: 'SettingFinance',
            component: () => import('views/settingPage/finance/settingFinancePage.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting'].pages['finance-vat-code'],
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          },
          {
            path: 'terms-of-payment',
            name: 'SettingFinanceTermsOfPayment',
            component: () => import('views/settingPage/finance/settingFinancePage.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages['setting'].pages['finance-terms-of-payment'],
              paginations: {
                page: 1,
                limit: 10,
              },
            },
          }
        ]
      },
      {
        path: 'template',
        name: 'SettingTemplate',
        component: () => import('views/settingPage/templates/settingTemplate.vue'),
        meta: {
          access: { abilities: ['edit_default_content_settings'] },
          responsive: true,
          breadCrumbLocalStorage: 'translations',
          breadCrumb: (translation) => translation.pages.sales_project['price_offer_terms-labels'].templates,
        },
        children: [
          {
            path: 'offer',
            name: 'SettingOfferTemplate',
            component: () => import('views/settingPage/templates/settingTemplateOfferPage.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.projects_status.status.tsenopredlozhenie,
            },
            children: [
              {
                path: 'edit',
                name: 'SettingOfferTemplateEdit',
                component: () => import('views/settingPage/templates/settingTemplateOfferPage.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.common.breadcrumbs.redaktirovanie,
                },
              },
            ],
          },
          {
            path: 'setting-letter',
            name: 'SettingLetter',
            component: () => import('views/settingPage/templates/settingTemplateLetterPage.vue'),
            meta: {
              responsive: true,
              breadCrumbLocalStorage: 'translations',
              breadCrumb: (translation) => translation.pages.sales_project['price_offer_terms-labels']['offer_letter'],
            },
            children: [
              {
                path: 'edit',
                name: 'SettingLetterEdit',
                component: () => import('views/settingPage/templates/settingTemplateLetterPage.vue'),
                meta: {
                  responsive: true,
                  breadCrumbLocalStorage: 'translations',
                  breadCrumb: (translation) => translation.pages.common.breadcrumbs.redaktirovanie,
                },
              },
            ],
          },
        ]
      },
    ],
  },
]
